import axios from 'axios';

class BaseRepository {
  constructor(baseUrl) {
    let cancelSource = axios.CancelToken.source();
    this.cancelToken = cancelSource;

    this.axiosInstance = axios.create({
      baseURL: baseUrl,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-TOKEN": document.head.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      },
      timeout: 100000
    });


    // Add a request interceptor
    this.axiosInstance.interceptors.request.use(function (config) {
      config.cancelToken = cancelSource.token;
      return config;
    }, function (error) {
      return Promise.reject(error);
    });

    // Add a response interceptor
    this.axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        // Extra config after call api here
        return Promise.reject(error);
      }
    );
  }

  /* Handle response */
  processError = (err) => {
    throw err.response;
  };
  
  responseBody = (res) => res.data;

  /* Method Query */
  query = (url, method, ...config) => {
    return this.axiosInstance.request({
      url,
      method,
      ...config
    }).then(this.responseBody).catch(this.processError)
  }

  /* Method GET */
  get = (url, params = {}) =>
    this.axiosInstance.get(url, { params: params }).then(this.responseBody).catch(this.processError)

  /* Method POST */
  post = (url, data) =>
    this.axiosInstance.post(url, data).then(this.responseBody).catch(this.processError);

  /* Method PUT */
  put = (url, data) =>
    this.axiosInstance.put(url, data).then(this.responseBody).catch(this.processError)

  /* Method DELELE */
  delete = (url) => this.axiosInstance.delete(url).then(this.responseBody).catch(this.processError)

  /* Method GET */
  postWithFile = (url, data) =>
    this.axiosInstance
      .post(url, data, { headers: { "Content-Type": "multipart/form-data" } })
      .then(this.responseBody);
}

export default BaseRepository;